import React from 'react'
import LoginForm from './LoginForm/LoginForm'
const index = () => {
  return (
    <div style={{marginTop: "120px"}}>
        <LoginForm/>
    </div>
  )
}

export default index
